import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideBarComponent } from 'src/app/private/create-matter/modal/side-bar/side-bar.component';
import { FileSelectComponent } from 'src/app/private/create-matter/modal/steps/file-select/file-select.component';
import { CreateMatterComponent } from 'src/app/private/create-matter/create.component';
import { CreateMatterModalComponent } from 'src/app/private/create-matter/modal/modal.component';
import { PaymentRequiredComponent } from 'src/app/private/create-matter/modal/payment-required/payment-required.component';
import { MatterDetailsStepComponent } from 'src/app/private/create-matter/modal/steps/matter-details/matter-details.component';
import { MatterDocumentsUploadComponent } from 'src/app/private/create-matter/modal/steps/matter-documents/matter-documents-upload.component';
import { CreateMatterSummaryComponent } from 'src/app/private/create-matter/summary/summary.component';
import { ComponentsModule } from '@components/components.module';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';
import { CoreModule } from '@core/core.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UiModule } from 'src/app/ui/ui.module';
import { IconsModule } from 'src/app/ui/icons/icons.module';
import { SectionComponent } from './components/section/section.component';
import { ApsEditAnchorComponent } from './components/aps-edit-anchor/aps-edit-anchor.component';
import { MissingInfoAnchorComponent } from './components/missing-info-anchor/missing-info-anchor.component';
import { MatTooltipModule } from '@angular/material/tooltip';

const components = [
	SideBarComponent,
	FileSelectComponent,
	CreateMatterComponent,
	CreateMatterModalComponent,
	PaymentRequiredComponent,
	MatterDetailsStepComponent,
	MatterDocumentsUploadComponent,
	CreateMatterSummaryComponent,
	SectionComponent,
	ApsEditAnchorComponent,
	MissingInfoAnchorComponent,
];

@NgModule({
	declarations: [...components],
	imports: [
		CommonModule,
		ComponentsModule,
		AtomicModule,
		CoreModule,
		FormsModule,
		RouterModule,
		UiModule,
		IconsModule,
		MatTooltipModule,
	],
	exports: [...components],
})
export class CreateMatterModule {}
